import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';

const MessageContentCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Tooltip label={rowData.rawLink}>
            <Text
                maw={400}
                truncate='end'>
                {rowData.rawLink}
            </Text>
        </Tooltip>
    );
};

const LinkColumn = () => ({
    accessorKey: 'rawLink',
    header: 'Link',
    size: 2,
    minSize: 300,
    Cell: ({ cell }) => <MessageContentCell cell={cell} />,
});
export default LinkColumn;
